/** Portrait framing keeps the crowd visible while giving distant threats more screen space. */
export function chaseFraming(width: number, height: number, bossDistance: number, out = { distance: 8, height: 4.1, fov: 0.95 }): { distance: number; height: number; fov: number } {
  const portrait = Math.max(0, Math.min(1, (height / Math.max(1, width) - 0.8) / 0.8));
  const encounter = Math.max(0, Math.min(1, (55 - bossDistance) / 35));
  out.distance = 8 + portrait * (2.5 + encounter * 0.6);
  out.height = 4.1;
  out.fov = 0.95 - portrait * (0.13 + encounter * 0.035);
  return out;
}
